module.exports = __webpack_public_path__ + "img/ins.fc54ef48.svg";